let audioCtx;

export function unlockAudio() {
    if (audioCtx?.state === "running") return;

    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    audioCtx.resume().then(() => {
        console.log("✅ AudioContext unlocked");
    });
}

export function playNotificationSound(specialType = false) {
    if (!audioCtx) {
        console.warn("🔒 Audio not unlocked yet");
        return;
    }

    if (specialType) {
        const audio = new Audio("/sounds/notification_special.wav");
        const source = audioCtx.createMediaElementSource(audio);
        source.connect(audioCtx.destination);
        audio.play();
    } else {
        const audio = new Audio("/sounds/notification.mp3");
        const source = audioCtx.createMediaElementSource(audio);
        source.connect(audioCtx.destination);
        audio.play();
    }
}
